jQuery(document).ready(function() {
		
	jQuery('.video-component .video-region-wrapper .js-play-video').click(function(){
        jQuery(this).hide();
    })
	
}); //Document Ready End


